// helperEventFormazione.jsx
import React, { useState, useEffect } from 'react';
import Joyride from 'react-joyride';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const TOUR_STORAGE_KEY = 'helperEventFormazioneTourSeen';

/**
 * HelperEventFormazione
 * @param {{ isManager: boolean }} props
 */
export default function HelperEventFormazione({ isManager }) {
  // Passi manager includono anche i passi comuni
  const managerSteps = [
    { target: '#ED-descrizione', content: 'Inserisci qui la descrizione del corso.', disableBeacon: true },
    { target: '#ED-start', content: 'Seleziona la data e l\'ora di inizio.', disableBeacon: true },
    { target: '#ED-durata', content: 'Specifica la durata in ore.', disableBeacon: true },
    { target: '#ED-istruttore1', content: 'Scegli il primo istruttore.', disableBeacon: true },
    { target: '#ED-istruttore2', content: 'Scegli il secondo istruttore (opzionale).', disableBeacon: true },
    { target: '#ED-Nr-istruttore1', content: 'Scegli il numero di persone per il primo istruttore.', disableBeacon: true },
    { target: '#ED-Nr-istruttore2', content: 'Scegli il numero di persone per il secondo istruttore (opzionale).', disableBeacon: true },
    { target: '#ED-add-presence', content: 'Usa questo pulsante per confermare/rimuovere la presenza.', disableBeacon: true },
    { target: '#ED-remove-self', content: 'Usa questo pulsante per rimuovere una iscrizione pre-esistente.', disableBeacon: true },
    { target: '#ED-add-user', content: 'Aggiungi utenti al corso usando questo pulsante.', disableBeacon: true },
    { target: '#ED-DeleteEvent', content: 'Elimina il tuo corso se non è più necessario.', disableBeacon: true },
    { target: '#ED-CancelEvent', content: 'Usa questo pulsante per uscire senza confermare.', disableBeacon: true },
    { target: '#ED-SaveEvent', content: 'Infine, salva le modifiche con questo pulsante.', disableBeacon: true },
  ];

  // Passi utente base
  const userSteps = [
    { target: '#ED-user-info', content: 'Qui puoi gestire la tua iscrizione al corso .', disableBeacon: true },
    { target: '#ED-add-self', content: 'Usa questo pulsante per iscriverti ora.', disableBeacon: true },
    { target: '#ED-remove-self', content: 'Usa questo pulsante per rimuovere la tua iscrizione.', disableBeacon: true }
  ];

  // Selezione dinamica dei passi
  const steps = isManager ? managerSteps : userSteps;
  const [run, setRun] = useState(false);

  useEffect(() => {
    // Solo attiviamo il tour su click, nessun avvio automatico
    localStorage.getItem(TOUR_STORAGE_KEY);
  }, []);

  const handleStart = () => {
    localStorage.setItem(TOUR_STORAGE_KEY, 'true');
    setRun(true);
  };

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if (status === 'finished' || status === 'skipped') {
      setRun(false);
    }
  };

  return (
    <>
      <Tooltip title="Aiuto">
        <IconButton
          onClick={handleStart}
          sx={{ position: 'absolute', top: 18, left: 160, zIndex: 1200 }}
        >
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>

      <Joyride
        steps={steps}
        run={run}
        continuous={true}
        showSkipButton={true}
        showProgress={false}
        disableBeacon={true}
        locale={{
          back: 'Indietro',
          close: 'Chiudi',
          last: 'Fine',
          next: 'Avanti',
          skip: 'Salta'
        }}
        callback={handleJoyrideCallback}
        styles={{
          options: {
            arrowColor: '#fff',
            backgroundColor: '#2C5282',
            primaryColor: '#1976d2',
            textColor: '#fff',
            zIndex: 1300
          },
          tooltipContainer: {
            transition: 'none !important'
          }
        }}
      />
    </>
  );
}
